<template>
  <div class="result_box">
    <div class="option_row">
      <div class="select_grid">
        <div @click="changeOrder('timeOrder')">
          按时间排序<i :class="timeOrder ? 'iconfont up' : 'iconfont down'"
            >&#xe606;</i
          >
        </div>
        <div @click="changeOrder('amountOrder')">
          按金额排序<i :class="amountOrder ? 'iconfont up' : 'iconfont down'"
            >&#xe606;</i
          >
        </div>
        <div @click="changeOrder('companyOrder')">
          按企业排序<i :class="companyOrder ? 'iconfont up' : 'iconfont down'"
            >&#xe606;</i
          >
        </div>
        <div @click="changeOrder('supplierOrder')">
          按供应商排序<i
            :class="supplierOrder ? 'iconfont up' : 'iconfont down'"
            >&#xe606;</i
          >
        </div>
      </div>
      <span style="line-height: 3.49vw; position: relative; right: 2vw"
        >找到 {{ totalElements }} 条 相关结果</span
      >
    </div>
    <div class="result_row">
      <div
        class="result_item finger"
        v-for="(item, index) in content"
        :key="index"
        @click="acceptOrder(item)"
      >
        <div></div>
        <div>
          {{ item.orderName
          }}<span class="item_tag">{{
            getDictMapItem("release_type", item.releaseType).label
          }}</span>
        </div>
        <div class="amount_time">
          <p>{{ item.settlementPrice }}元</p>
          <p>发布于{{ parseDay(item.releaseTime) }}</p>
        </div>
        <div>{{ item.orderDescribe }}</div>
      </div>
    </div>
    <div class="result_row">
      <div style="height: 2.7vw"></div>
      <el-pagination
        background
        @prev-click="prev"
		@current-change="curv"
        @next-click="nextv"
        layout="prev, pager, next"
        :total="totalElements"
      >
      </el-pagination>
      <div style="height: 2.7vw"></div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="18vw">
      <login></login>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  queryYumiOrder,
  searchOrder,
  queryTopFwlxYumiOrder,
} from "../../api/cus.js";
import { add } from "../../api/orderAccept.js";
import { parseDay } from "../../utils/index.js";
import initDict from "@/mixins/initDict";
import login from "../login/login.vue";
import checkPermission from "../../utils/permission.js";
import { regionData } from "element-china-area-data";
export default {
  mixins: [initDict],
  components: {
    login,
  },
  data() {
    return {
      dq: [],
      dialogVisible: false,
      timeOrder: true,
      amountOrder: true,
      companyOrder: true,
      supplierOrder: true,
      order: "",
      page: 0,
      size: 10,
      totalElements: 0,
      sort: "createDateTime,desc",
      queryParams: {},
      content: "",
    };
  },
  created() {
    this.topOrderTypeQuery();
    for (var o of regionData) {
      o.status = "none";
      o.type = "dq";
      o.children = null;
      this.dq.push(o);
    }
    this.getDictMap("release_type,release_pattern");
    let params = {
      page: this.page,
      size: this.size,
      sort: "createDateTime,desc",
      ...this.Search,
    };

    searchOrder(params).then((res) => {
      this.content = res.content;
      this.totalElements = res.totalElements;
    });
  },
  computed: {
    ...mapGetters(["Query", "Login", "Search"]),
  },
  methods: {
    parseDay,
    prev() {
      let params = {
        page: this.page - 1,
        size: this.size,
        sort: "createDateTime,desc",
      };
      searchOrder(params).then((res) => {
		  this.page = this.page - 1
      this.content = res.content;
      this.totalElements = res.totalElements;
    });
    },
    nextv() {
      let params = {
        page: this.page + 1,
        size: this.size,
        sort: "createDateTime,desc",
      };
      searchOrder(params).then((res) => {
		  this.page = this.page + 1
      this.content = res.content;
      this.totalElements = res.totalElements;
    });
    },
	curv(i){
		  let params = {
        page: i-1,
        size: this.size,
        sort: "createDateTime,desc",
      };
      searchOrder(params).then((res) => {
		  this.page = i-1
      this.content = res.content;
      this.totalElements = res.totalElements;
    });
	},
    changeOrder(type) {
      (this.sort = type + this[type] ? "asc" : "desc"),
        (this[type] = !this[type]);
      let params = {
        page: this.page,
        size: this.size,
        //sort: "createDateTime,desc"
        sort: this.sort,
        ...this.queryParams,
      };

      this.queryOrderAction(params);
    },
    queryOrderAction(params) {
      params = this.handleDq(params);
      console.log("[params]", params);

      queryYumiOrder(params).then((res) => {
        this.content = res.content;
        this.totalElements = res.totalElements;
      });
    },
    handleDq(params) {
      if (params.dq) {
        for (let o of this.dq) {
          if (o.value === params.dq) {
            params.dq = o.label;
            return params;
          }
        }
      } else {
        return params;
      }
    },

    acceptOrder(item) {
      console.log("[item]", item);
      //首先验证登录
      if (this.Login.username) {
        if (item.releaseType == "public") {
          if (checkPermission(["YUMIENTERPRISEUSER_SELECT_SELF"])) {
            this.$alert("您的身份是企业用户，无法承接", "提示", {
              confirmButtonText: "确定",
            });
            return false;
          }
          this.sendAcceptOrderMsg(item);
        } else {
          this.$alert("该订单已被指派，无法承接", "提示", {
            confirmButtonText: "确定",
          });
        }
      } else {
        this.dialogVisible = true;
      }
    },
    sendAcceptOrderMsg(item) {
      this.$confirm("是否确认承接该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let accept = {
            //在后台获取
            supplierId: null,
            orderId: item.id,
            enterpriseId: item.enterprise.id,
            status: "send",
          };

          add(accept).then((res) => {
            this.$message({
              type: "success",
              message: "承接成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    topOrderTypeQuery() {
      if (this.$route.query.topFwlx) {
        let params = {
          page: this.page,
          size: this.size,
          sort: "createDateTime,desc",
          ...this.$route.query,
        };
        queryTopFwlxYumiOrder(params).then((res) => {
          this.content = res.content;
          this.totalElements = res.totalElements;
        });
      }
    },
  },
  watch: {
    Query(val) {
      console.log("[this.query]", this.Query);
      this.queryParams = {};
      for (var o of this.Query) {
        if (o) this.queryParams[o.type] = o.value;
      }
      let params = {
        page: this.page,
        size: this.size,
        sort: "createDateTime,desc",
        ...this.queryParams,
      };
      this.queryOrderAction(params);
    },
    Search(val) {
      console.log("[watch:::Search]", val);

      let params = {
        page: this.page,
        size: this.size,
        sort: "createDateTime,desc",
        ...val,
      };
      this.searchOrder(params);
    },
    $route(val) {
      console.log("[val]", val);
      this.topOrderTypeQuery();
    },
  },
};
</script>

<style>
.amount_time p:nth-child(1) {
  margin: 0;
  font-size: 1.458vw;
  color: #ed6442;
  font-weight: 800;
}
.amount_time p:nth-child(2) {
  margin: 0;
  color: #777777;
  font-size: 0.92vw;
  font-weight: 700;
}
.result_box {
  margin-left: 10.667vw;
}
.item_tag {
  width: 2.188vw;
  height: 1.25vw;
  background-color: #eff4f9;
  border-radius: 0.104vw;
  border: solid 0.052vw #409be8;
  color: #409be8;
  font-size: 0.833vw;
  margin-left: 0.625vw;
  padding-left: 0.5vw;
  padding-right: 0.5vw;
}
.option_row {
  margin-top: 2.135vw;

  width: 78.646vw;
  height: 3.49vw;
  background-color: #fbfbfb;
  display: flex;
  justify-content: space-between;
  border-top: #809ee8 solid 1px;
  box-shadow: 0vw 0vw 0.208vw 0vw rgba(0, 0, 0, 0.15),
    inset 0vw 0.052vw 0vw 0vw #809ee8;
}
.select_grid {
  display: grid;
  grid-template-columns: 8.854vw 8.854vw 8.854vw 8.854vw;
  width: 35.646vw;
  height: 3.49vw;
}
.select_grid div {
  border-right: #c5c5c5 solid 1px;
  line-height: 3.49vw;
}
.result_row {
  height: auto;
  width: 78.646vw;
  background-color: #ffffff;
}
.result_item {
  padding-top: 2vw;
  padding-bottom: 2vw;
  height: 5.115vw;
  padding-left: 2.3vw;
  display: grid;
  grid-template-columns: 5.6vw 50vw 8.5vw;
  grid-template-rows: 1.2vw 3vw;
  grid-row-gap: 1vw;
  grid-column-gap: 1vw;
  transition: all 0.5s ease-in-out;
}
.result_item:hover {
  background-color: #dde5ef;
}
.result_item div:nth-child(1) {
  grid-row-start: span 2;
  background-image: url(../../assets/商业服务icon.png);
  background-size: 100% 100%;
}
.result_item div:nth-child(2) {
  font-size: 1.25vw;
  color: #222222;
  font-weight: 800;
  text-align: left;
}
.result_item div:nth-child(3) {
  grid-row-start: span 2;
  position: relative;
  left: 8vw;
}
.result_item div:nth-child(4) {
  font-size: 0.938vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.563vw;
  letter-spacing: 0vw;
  color: #777777;
  text-align: left;
  overflow: hidden;
}
.up {
  display: inline-block;
  transition: all 0.5s ease-in-out;
  transform: rotate(0deg);
  color: #809ee8;
}
.down {
  display: inline-block;
  transition: all 0.5s ease-in-out;
  transform: rotate(180deg);
  color: #809ee8;
}
</style>
